import React from "react";
import Navbar from "../components/navbar/navbar";
import AboutBanner from "../components/banner-about/banner-about";
import Skills from "../components/skills/skills";
import Education from "../components/education/education";
import Experience from "../components/experience/experience";
import Footer from "../components/footer/footer";

const About: React.FC = () => {


  return (
    <>
      <Navbar/>
      <div className="page-content">
        <AboutBanner/>
        <Skills/>
        <Education/>
        <Experience/>
        <Footer />
      </div>
    </>
  );
};

export default About;